// extracted by mini-css-extract-plugin
export default {"list":"Review-li_list__SLxXS"};